import ParentAccountReporting from './ParentAccountReporting';

export default ParentAccountReporting;
